<template>
  <v-flex class="school-map-search-form-wrapper">
    <v-form
      @submit.prevent="schoolSearch()"
      class="school-map-search-form"
      ref="schoolMapSearchForm"
    >
      <v-flex xs12>
        <v-flex xs6 md4>
          <v-flex class="school-map-province-wrapper">
            <v-menu
              ref="schoolMapProvinceMenu"
              :close-on-content-click="false"
              content-class="school-map-province"
            >
              <template v-slot:activator="{ on }">
                <v-btn flat class="province-menu-top" background-color="transparent" v-on="on">
                  {{ province }}
                  <v-icon>expand_more</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in provinces"
                  :key="index"
                  :class="[{'single-items': !item.languages, 'group-items': item.languages}]"
                >
                  <v-list-tile-title
                    v-if="!item.languages"
                    @click="closeProvinceMenu(item.value);"
                  >{{ item.text }}</v-list-tile-title>
                  <v-list-group
                    v-if="item.languages"
                    no-action
                    v-model="subMenuValue">
                    <template v-slot:activator>
                      <v-list-tile>
                        <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                      </v-list-tile>
                    </template>
                    <v-list-tile class="sub-items">
                      <v-list-tile-title
                        @click="closeProvinceMenu(item.value, 'fr');"
                        v-text="$t('French')"
                      ></v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile class="sub-items">
                      <v-list-tile-title
                        @click="closeProvinceMenu(item.value, 'en');"
                        v-text="'English'"
                      ></v-list-tile-title>
                    </v-list-tile>
                  </v-list-group>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-flex>
        <v-flex xs-12>
          <v-layout>
            <v-dialog persistent v-model="modalProvince" width="500" content-class="modal-province">
              <v-card>
                <v-card-title>
                  <v-layout
                    align-center
                    justify-space-between
                    row
                    fill-height
                    wrap
                    class="dialog-title"
                  >
                    {{$t('province_select')}}
                  </v-layout>
                </v-card-title>
                <form class="province-switcher--form">
                  <v-select
                    append-icon="expand_more"
                    value="none"
                    placeholder="Please select a province"
                    :items="provinces"
                    @change="closeModalProvince()"
                    v-model="province"
                  ></v-select>
                  <v-layout flex justify-center>
                    <v-btn
                      class="v-btn v-btn--flat v-btn--round theme--light"
                      @click="closeModalProvince()"
                    >Select province</v-btn>
                  </v-layout>
                </form>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-flex>
        <v-flex xs-12>
          <v-layout>
            <v-dialog persistent v-model="modalLanguage" width="500" content-class="modal-province">
              <v-card>
                <v-card-title>
                  <v-layout
                    align-center
                    justify-space-between
                    row
                    fill-height
                    wrap
                    class="dialog-title"
                  >Please, select a language:
                  </v-layout>
                </v-card-title>
                <form>
                  <v-select
                    append-icon="expand_more"
                    value="none"
                    :items="languages"
                    v-model="languageInput"
                    placeholder="Select a language"
                  ></v-select>
                  <v-btn class="v-btn v-btn--flat v-btn--round theme--light ml-3" @click="closeModalLanguage()">Select</v-btn>
                </form>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-flex>
        <v-flex xs12 :class="{ md8: province != 'Québec', md4: province == 'Québec' }">
          <v-tabs class="school-education-level" v-model="schoolEducationLevel" prev-icon="">
            <v-tab
            v-for="tab in tabs"
            :key="tab.level"
            :class="'education-level-' + tab.level"
            :href="'#' + tab.level"
            @click.stop.prevent="$gtag.event(tab.level + ' Schools');setSchoolEducationLevel(tab.level);"
            >
              <span class="school-education-level-tab-value" v-html="$t('education_level.' + tab.level)"></span>
            </v-tab>
          </v-tabs>
        </v-flex>
        <v-layout row wrap justify-space-between class="school-map-search-content">
          <v-flex md6 xs12 class="school-map-search-keyword-desktop hidden-sm-and-down">
            <v-layout row wrap>
              <v-flex xs9 class="autocomplete-wrapper">
                <v-autocomplete v-if="!searchKey"
                  :auto-select-first = "true"
                  v-model="keyword"
                  item-value="index"
                  item-text="label"
                  :items="autocompleteItems"
                  :search-input.sync="autocompleteSearch"
                  :loading="autocompleteLoading"
                  :label="$t('Search for')"
                  :placeholder="$t('search_placeholder')"
                  hide-no-data
                  id="keyword"
                  @input="setAutocompleteItem();schoolSearch();$gtag.event('Search For');"
                >
                  <template v-slot:item="{item}">
                    <v-flex d-flex align-center fill-height>
                      <span class="autocomplete-label">{{item.label}}</span> <v-chip v-if="item.type == 'city'">{{$t('City')}}</v-chip>
                    </v-flex>
                  </template>
                </v-autocomplete>
                <v-icon v-if="keyword"
                  class="clear-search"
                  @click.stop.prevent="resetKeywordFilter('ResetKeyword');"
                >clear</v-icon>
              </v-flex>
              <v-flex xs1 class="submit-mobile hidden-md-and-up">
                <v-btn
                  round
                  flat
                  type="submit"
                  @click="$gtag.event('Search');"
                >
                  <v-icon>search</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex md1 class="hidden-sm-and-down school-map-types">
            <v-select
              hide-details
              append-icon="expand_more"
              label="Type"
              v-model="schoolType"
              :items="schoolTypes"
              @change="$gtag.event('Type');"
            ></v-select>
          </v-flex>
          <v-flex md2 class="hidden-sm-and-down school-map-submit text-xs-center">
            <v-btn round flat type="submit" @click="$gtag.event('Search');">
              {{ $t("Search") }}
              <v-icon>search</v-icon>
            </v-btn>
          </v-flex>
          <v-flex md3 class="school-map-search-action">
            <v-layout row wrap justify-space-between>
              <v-flex xs3 class="hidden-md-and-up school-map-search-keyword-toggle text-xs-left">
                <v-btn align-left flat @click="$gtag.event('Search');toggleSearchKey();">
                  <v-flex>
                    <v-icon :class="{active: searchKey}">search</v-icon>
                    <div class="text">Search</div>
                  </v-flex>
                </v-btn>
              </v-flex>
              <v-flex xs3 md1 class="school-map-search-filters text-xs-left">
                <v-btn
                  @click="showFilter = !showFilter; resizeFilter();$gtag.event('Filters');"
                  :class="{active: showFilter}"
                  flat
                >
                  <div class="icon"></div>
                  <v-flex class="text">{{ $t('Filters') }}</v-flex>
                </v-btn>

                <v-layout
                  justify-center
                  row
                  wrap
                  v-if="showFilter"
                  class="form-group-filter-wrapper"
                  id="form-group-filter-wrapper"
                >
                  <v-toolbar flat>
                    <v-spacer></v-spacer>
                    <v-btn flat @click.stop="showFilter = false">
                      {{ $t('Close Filters') }}
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex xs12 class="form-group-filter">
                    <v-container grid-list-md>
                      <v-layout row wrap>
                        <v-flex xs12 md4>
                          <v-select
                            :label="$t('School authority (district)')"
                            id="school-autority"
                            :items="schoolAutorities"
                            v-model="schoolAutority"
                            hide-details
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 md2>
                          <v-select
                            :label="$t('Languages')"
                            id="school-language"
                            v-model="schoolLanguage"
                            :items="schoolLanguages"
                            hide-details
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 md3>
                          <v-select
                            :label="$t('School names')"
                            id="school-name"
                            v-model="schoolName"
                            :items="schoolNames"
                            hide-details
                          ></v-select>
                        </v-flex>
                        <v-flex xs6 md3>
                          <v-select
                            label="Types"
                            id="types"
                            v-model="schoolType"
                            :items="schoolTypes"
                            @change="$gtag.event('Type');"
                            hide-details
                          ></v-select>
                        </v-flex>
                      </v-layout>

                      <v-layout row wrap>
                        <v-flex xs12 md8 class="school-rating">
                          <label for="searchRating" class="form-solo-label">{{ $t('Score out of 10') }}</label>
                          <b-form-slider
                            id="searchRating"
                            style="width: 100%"
                            ref="searchRating"
                            v-model="rating"
                            :range="true"
                            :ticks="ticks"
                            :ticks-labels="ticks_labels"
                            :range-highlights="rangeHighlights"
                            tooltip="hide"
                          ></b-form-slider>
                        </v-flex>
                        <v-flex class="school-map-apply">
                          <v-btn flat round type="submit">{{ $t('Apply') }}</v-btn>
                        </v-flex>
                        <v-flex class="school-map-search-reset">
                          <a href="#" @click.prevent="resetAllFilter('resetAll')">{{ $t('Reset all') }}</a>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3 md1 class="school-map-search-swither-map text-xs-center">
                <v-btn align-center flat @click="toggleSwitcherMapList('map');$gtag.event('Map View');">
                  <v-flex>
                    <v-icon :class="{active: switcherMapList == 'map'}">place</v-icon>
                    <div class="text">{{ $t('Map view') }}</div>
                  </v-flex>
                </v-btn>
              </v-flex>
              <v-flex xs3 md1 class="school-map-search-swither-list text-xs-right">
                <v-btn flat align-center @click="toggleSwitcherMapList('list');$gtag.event('List View');">
                  <v-flex>
                    <v-icon :class="{active: switcherMapList == 'list'}">list</v-icon>
                    <div class="text">{{ $t('List view') }}</div>
                  </v-flex>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex md6 xs12 class="school-map-search-keyword" v-if="searchKey">
            <v-layout row wrap>
              <v-flex xs10 class="autocomplete-wrapper">
                <v-autocomplete
                  :auto-select-first = "true"
                  v-model="keyword"
                  item-value="index"
                  item-text="label"
                  :items="autocompleteItems"
                  :search-input.sync="autocompleteSearch"
                  :loading="autocompleteLoading"
                  :label="$t('Search for')"
                  :placeholder="$t('search_placeholder')"
                  hide-no-data
                  id="keyword"
                  @input="setAutocompleteItem();schoolSearch()"
                >
                <template v-slot:item="{item}">
                    <v-flex d-flex align-center fill-height>
                      <span class="autocomplete-label">{{item.label}}</span> <v-chip v-if="item.type == 'city'">{{$t('City')}}</v-chip>
                    </v-flex>
                  </template>
                </v-autocomplete>
                <v-icon v-if="keyword"
                        class="clear-search"
                        @click.stop.prevent="resetKeywordFilter('ResetKeyword');"
                >clear</v-icon>
              </v-flex>
              <v-flex xs2 class="submit-mobile text-xs-right">
                <v-btn round flat type="submit">
                  <v-icon>arrow_forward</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-form>
  </v-flex>
</template>
<script>
import GeolocationService from "@/services/Geolocation.service.js";
import RepositoryFactory from "@/services/RepositoryFactory";
import 'bootstrap-slider/dist/css/bootstrap-slider.css';
import bFormSlider from 'vue-bootstrap-slider/es/form-slider';

const SchoolService = RepositoryFactory.get("schools");
const StorageService = RepositoryFactory.get('storage');

import Vuex from 'vuex';
import L from "leaflet";

export default {
  name: "SchoolMapSearch",
  data() {
    return {
      schoolAutorities: [],
      autocompleteItem: null,
      languages: [
        { value: 'en', text: 'English' },
        { value: 'fr', text: 'French' }
      ],
      languageInput: null,
      subMenuValue: false,
      keyword: null,
      schoolTypes: [],
      autocompleteLoading: false,
      autocompleteItems: [],
      autocompleteSearch: null,
      searchKey: false,
      modalProvince: false,
      modalLanguage: false,
      isMobile: false,
      schoolAutority: "",
      schoolESLItem: "",
      schoolESL: [
        { value: "", text: "All" },
        { value: "0|5", text: "0% - 5%" },
        { value: "5.1|20", text: "5.1% - 20%" },
        { value: "20.1|40", text: "20.1% - 40%" },
        { value: "40.1", text: "Over 40%" }
      ],
      schoolSpecialNeed: "",
      schoolSpecialNeeds: [
        { value: "", text: "All" },
        { value: "0|10", text: "0% - 10%" },
        { value: "10.1|20", text: "10.1% - 20%" },
        { value: "20.1", text: "Over 20%" }
      ],
      schoolLanguage: "",
      schoolName: "",
      rating: [0, 10],
      showFilter: false,
      schoolType: "",
      schoolEducationLevel: "elementary",
      schoolElementaryActive: true,
      ticks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      ticks_labels: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      rangeHighlights: [
        { start: 0, end: 4, class: "slider-red" },
        { start: 4, end: 6, class: "slider-orange" },
        { start: 6, end: 7.5, class: "slider-yellow" },
        { start: 7.5, end: 10, class: "slider-green" }
      ]
    };
  },
  methods: {
    resetUserLocation() {
      let currentMapProvince = StorageService.getItem('currentMapProvince');
      // Check if province is really set with one in the list.
      const currentProvince = this.$store.state.provinceList.filter(function (province) {
        if (province.name == currentMapProvince) {
          return province;
        }
      });

      // If province not found, delete so the popup can come back.
      if (currentProvince == '') {
        StorageService.removeItem('currentMapProvince');
        currentMapProvince = null;
      }

      if (currentMapProvince) {
        let vm = this;
        vm.province = currentMapProvince;
        if (vm.province == 'Québec') {
          this.schoolEducationLevel = 'secondary';
          this.$store.commit("CURRENT_EDUCATION_LEVEL", 'secondary');
        }
        let listProvinces = this.$store.state.provinceList;
        listProvinces.forEach(function(value) {
          if (value.name === currentMapProvince) {
            vm.$store.dispatch("setCurrentMapLocation", value.location);
          }
        });
      } else {
        this.wrapperUserLocation();
      }
      this.$store.commit('CURRENT_MAP_ZOOM', 13);
    },
    showAutocomplete() {
      document.getElementsByClassName("v-autocomplete__content")[0].style.display='block';
    },
    closeProvinceMenu(province, language = "en") {
      this.$i18n.locale  = language;
      this.$store.dispatch('setCurrentLanguage', language);
      this.$refs.schoolMapProvinceMenu.save();
      this.subMenuValue = false;
      this.$store.commit('SET_COMPARE_SCHOOL', []);
      this.province = province;
      if (province == 'Québec') {
        this.schoolEducationLevel = 'secondary';
        this.$store.commit("CURRENT_EDUCATION_LEVEL", 'secondary');
      }
      this.resetAllFilter('closeProvinceMenu');
    },
    toggleSearchKey() {
      this.searchKey = !this.searchKey;
    },
    closeModalProvince() {
      if (this.province != null) {
      this.modalProvince = false;
      location.reload();
      }
    },
    closeModalLanguage() {
      this.modalLanguage = false;
      this.$i18n.locale = this.languageInput;
      this.$store.dispatch('setCurrentLanguage', this.languageInput);
      location.reload();
    },
    checkIsMobile() {
      this.isMobile = parseInt(document.documentElement.clientWidth) < 960;
    },
    resizeFilter() {
      setTimeout(() => {
        let filter = document.getElementById("form-group-filter-wrapper");
        if (filter != null) {
          let currentWidth = filter.clientWidth;
          let changeWidth = filter.getBoundingClientRect().left;
          if (this.isMobile) {
            document.getElementById("form-group-filter-wrapper").style.width =
              "100%";
          } else {
            if (changeWidth < 0 || currentWidth < 887) {
              document.getElementById("form-group-filter-wrapper").style.width =
                currentWidth + changeWidth + "px";
            }
          }
        }
      }, 50);
    },
    setSchoolEducationLevel(level) {
      this.schoolEducationLevel = level;
      this.$store.commit("CURRENT_EDUCATION_LEVEL", level);
      this.$store.commit('SET_COMPARE_SCHOOL', []);
      //this.resetAllFilter('setSchoolEducationLevel');
      this.querySelections('');
      this.schoolSearch('setSchoolEducationLevel');
      this.schoolElementaryActive = level === "elementary";
      this.getSchoolAreaNames(true).then(data => {
        this.schoolAutorities = data
      });
    },
    setAutocompleteItem() {
      if (this.keyword !== null && this.keyword !== undefined && this.autocompleteSearch != "") {
        let keyword = this.autocompleteAllTerms[this.keyword].label;
        let type =  this.autocompleteAllTerms[this.keyword].type;
        this.autocompleteItem = {
          keyword,
          type
        }
      }
    },
    schoolSearch (action) {

      document.querySelector('.application--wrap').classList.add('loading');
      setTimeout(() => {
        // Hide Autocomplete.
        document.getElementsByClassName("v-autocomplete__content")[0].style.display='none';

        let vm = this;
        let rating = this.rating.slice(0);

        let schools = vm.$store.state.searchSchoolList;
        let schoolsFilteredByEducationLevel = schools.filter(school => {
          return school.level == this.schoolEducationLevel;
        });
        let schoolsFiltered = [];
        schoolsFiltered = schoolsFilteredByEducationLevel.filter(school => {
          let keyword = "";
          let type = "";

          if (this.autocompleteItem) {
            keyword = this.autocompleteItem.keyword;
            type =  this.autocompleteItem.type;
          }


          return (
            (keyword && keyword != ""
              ? (school.name.toLowerCase().includes(keyword.toLowerCase()) && type == 'school') ||
                (school.city.toLowerCase().includes(keyword.toLowerCase()) && type == 'city')
              : true) &&
            school.level == this.schoolEducationLevel &&
            (this.schoolType != ""
              ? school.type.toLowerCase() == this.schoolType.toLowerCase()
              : true) &&
            ((school.score >= rating[0] && school.score <= rating[1])
              || (school.id == '2396281' && school.score == 'n/a')
            ) &&
            (this.schoolAutority != ""
              ? school.areaName == this.schoolAutority || school.adminBodyName == this.schoolAutority
              : true) &&
            (this.schoolLanguage != ""
              ? school.language.toLowerCase() == this.schoolLanguage.toLowerCase()
              : true) &&
            (this.schoolName != "" ? this.schoolName == school.id : true)
          );
        });
        this.setSchoolTypes(schoolsFilteredByEducationLevel);
        this.$store.commit("SEARCH_SCHOOL_LIST_FILTERED", schoolsFiltered);
        this.$store.commit("INITIAL_SEARCH_SCHOOL_LIST_FILTERED_COUNT", schoolsFilteredByEducationLevel.length);
        if (!action) {
          this.$root.$emit('centerMap');
        }

        this.showFilter = false;
        document.querySelector('.application--wrap').classList.remove('loading');
      }, 100);
    },
    resetKeywordFilter (action) {
      this.autocompleteItem = null;
      this.schoolName = "";
      this.keyword = null;
      if (this.schoolName === "" && this.schoolType === "" && this.schoolLanguage === "" && this.schoolAutority === "") {
        this.resetUserLocation();
      }
      this.schoolSearch(action);
    },
    resetAllFilter (action) {
      this.autocompleteItem = null;
      this.schoolESLItem = "";
      this.schoolType = "";
      this.schoolSpecialNeed = "";
      this.schoolLanguage = "";
      this.schoolName = "";
      this.rating = [0, 10];
      this.schoolAutority = "";
      this.keyword = null;
      this.resetUserLocation();
      this.querySelections('');
      this.getSchoolAreaNames(true).then(data => {
        this.schoolAutorities = data
      });
      this.schoolSearch(action);
    },
    toggleSwitcherMapList(view) {
      /*console.info({
        "element-model": 'Switcher Map/List',
        "action: ": `Switch to ${view}`,
        time: Math.floor(Date.now() / 1000)
      },"EVENT");*/
      this.$store.commit("SET_SWITCHER_MAP_LIST", view);
    },
    /**
     * Set automatically province, but only if userAddress-state is from Canada and
     * province is in the provinceList = ['British Columbia', 'Alberta', 'Quebec', 'Ontario']
     * Otherwise show modal
     * @param userAddress
     */
    setMapProvince(userAddress) {
      let vm = this;
      userAddress = JSON.parse(userAddress);

      if (
        typeof userAddress.country_code != "undefined" &&
        userAddress.country_code === "ca"
      ) {
        let isInListOfProvinces = false;
        let provinceList = this.$store.state.provinceList;
        for (let i = provinceList.length - 1; i >= 0; i--) {
          let province_name = provinceList[i].normalized ? provinceList[i].normalized : provinceList[i].name;
          if (province_name === userAddress.province) {
            isInListOfProvinces = true;
          }
        }
        if (isInListOfProvinces) {
          // Set Province bound.
          this.province = userAddress.province;
          // Set center Map to user location.
          this.$store.dispatch("setCurrentMapLocation", userAddress);

          if (userAddress.province == "Quebec") {
            this.modalLanguage = true;
          }
        }
        else {
          vm.modalProvince = true;
        }
      } else {
        vm.modalProvince = true;
      }
    },
    /**
     * 0. Check localStorage and set default province.
     * 1. get user location from browser service.
     * 2. set user location on state and localstorage
     * 3. then, using GeolocationService, get Address and set it on localstorage
     * 4. then, set MapProvince (select) and localStorage
     * 5. if user is outside of provinces, show modal
     * 6. set mapLocation (select) and state
     */
    wrapperUserLocation() {
      let self = this;
      if (navigator.geolocation) {
        let userLocation;
        navigator.geolocation.getCurrentPosition(function(position) {
          userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          self.setUserLocation(userLocation);
          self
            .setUserAddress(userLocation)
            .then(res => {
              return res;
            })
            .then(res => {
              let currentUserAddress = StorageService.getItem("userAddress");
              if (!currentUserAddress) {
                currentUserAddress = res;
              }
              self.setMapProvince(currentUserAddress);
            });
        }, function (e) {
          self.modalProvince = true;
          console.error(e);
        });
      }
      else {
        self.modalProvince = true;
      }
    },
    setUserLocation(userLocation) {
      this.$store.dispatch("setUserLocation", userLocation);
      StorageService.setItem("userLocation", JSON.stringify(userLocation));
    },
    /**
     * Use GeolocationService to get Address from userLocation: lat, lng.
     */
    setUserAddress(userLocation) {
      return new Promise(resolve => {
        let userAddress;
        GeolocationService.getLocation(userLocation.lat, userLocation.lng).then(
          res => {
            userAddress = {
              country_code: res.data.address.country_code,
              province: res.data.address.state
            };
            StorageService.setItem("userAddress", JSON.stringify(userAddress));
            resolve(userAddress);
          }
        );
      }).then(function(result) {
        return result;
      });
    },
    dynamicIcon(rating) {
      if (rating === 'n/a') {
        return require("../../assets/images/marker_grey.svg");
      }
      if (rating <= 4) {
        return require("../../assets/images/marker_red.svg");
      } else if (rating <= 5.9) {
        return require("../../assets/images/marker_orange.svg");
      } else if (rating <= 7.5) {
        return require("../../assets/images/marker_yellow.svg");
      } else {
        return require("../../assets/images/marker_green.svg");
      }
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },

    // TODO: Change the structure of data (school / SchoolList)
    async getLocations(topRight, bottomLeft) {
      // console.warn('GETTING LOCATIONS...');
      if (topRight === undefined && bottomLeft === undefined) {
        return false;
      }

      let provinces = this.$store.state.provinceList;
      let currentProvinceValue;
      provinces.forEach(province => {
        if (province.name == this.province) {
          currentProvinceValue = province.value;
        }
      });
      document.querySelector('.application--wrap').classList.add('loading');
      const schoolsByProvince = await SchoolService.getSchoolLocations(
        currentProvinceValue,
        topRight,
        bottomLeft
      );
      await this.processSchools(schoolsByProvince);
      document.querySelector('.application--wrap').classList.remove('loading');
    },
    async processSchools(schoolsByProvince) {
      let vm = this;
      let schoolList = [];
      for await (let schoolByProvince of schoolsByProvince) {
        if (schoolByProvince.location === null) {
          continue;
        }
        let icon = L.icon({
          iconUrl: vm.dynamicIcon(schoolByProvince.score),
          iconSize: [40, 40],
          iconAnchor: [20, 40]
        });
        schoolList.push({
          id: schoolByProvince.sid,
          name: schoolByProvince.title,
          ranking: schoolByProvince.ranking,
          type: schoolByProvince["IND_or_PUB"],
          location: L.latLng(schoolByProvince.location.lat, schoolByProvince.location.lon),
          icon: icon,
          trend: schoolByProvince.trend,
          score: schoolByProvince.score,
          level: schoolByProvince.level,
          city: schoolByProvince.city,
          areaName: schoolByProvince.areaName,
          adminBodyName: schoolByProvince.adminBodyName,
          language: schoolByProvince.language,
          postalCode: schoolByProvince.postalCode,
          province: schoolByProvince.province
        });
      }

      await vm.$store.dispatch("setSearchSchoolList", schoolList);
      let schoolListFiltered = [];
      for (let i = schoolList.length - 1; i >= 0; i--) {
        if (schoolList[i].level === this.schoolEducationLevel) {
          schoolListFiltered.push(schoolList[i]);
        }
      }
      this.setSchoolTypes(schoolListFiltered);

      vm.$store.commit("INITIAL_SEARCH_SCHOOL_LIST_FILTERED_COUNT", schoolListFiltered.length);
      vm.$store.commit("SEARCH_SCHOOL_LIST_FILTERED", schoolListFiltered);
    },
    async getSearchSchoolList () {
      let vm = this;
      return await vm.$store.state.searchSchoolList;
    },
    async getSchoolAreaNames (skipUpdate) {
      let provinces = this.$store.state.provinceList;
      let currentProvinceValue;
      provinces.forEach(province => {
        if (province.name === this.province) {
          currentProvinceValue = province.value;
        }
      });
      let schoolEducationLevel = this.schoolEducationLevel ? this.schoolEducationLevel : 'elementary';
      let schoolAreaNames = await SchoolService.getSchoolAreaNameByProvince(
        currentProvinceValue,
        schoolEducationLevel,
        skipUpdate
      );

      let school_authority = this.$t("All school authorities");
      let areaNames = [{ value: "", text: school_authority }];
      for (let i = schoolAreaNames.length - 1; i >= 0; i--) {
        areaNames.push({
          value: schoolAreaNames[i],
          text: schoolAreaNames[i]
        });
      }

      areaNames.sort((a, b) => {
        if ( a.value < b.value ) {
          return -1;
        }
        if ( a.value > b.value ) {
          return 1;
        }
        return 0;
      });
      return areaNames;
    },
    querySelections(v) {
      if (v !== undefined) {
        this.autocompleteLoading = true;
        setTimeout(() => {
          this.autocompleteItems = this.autocompleteAllTerms.filter(e => {
            if (!e.label) {
              return false;
            }
            return (
              (e.label || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
            );
          });
          this.autocompleteLoading = false;
        }, 0);
      }
    },
    setSchoolTypes(schools) {
      let schoolTypes = [];
      schoolTypes = [...new Set(schools.map(school => school.type))];
      schoolTypes = schoolTypes.map(type => {
        return { value: type, text: type };
      });
      schoolTypes.unshift({ value: '', text: this.$t('All types') });
      this.schoolTypes = schoolTypes;
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkIsMobile);
    this.checkIsMobile();

    window.addEventListener("resize", this.resizeFilter);
    this.resizeFilter();

   this.resetUserLocation();
   this.getSchoolAreaNames().then(data => {
     this.schoolAutorities = data
   });
  },
  computed: {
    ...Vuex.mapState({
      currentLanguage: state => state.currentLanguage
    }),
    schoolLanguages() {
      return [
        { value: "", text: this.$t("All Languages") },
        { value: "English", text: "English" },
        { value: "French", text: "French" }
      ]
    },
    tabs() {
      let tabs = [
        { level: 'elementary', show: this.province != 'Québec' },
        { level: 'secondary', show: true }
      ];

      return tabs.filter(tab => tab.show);
    },
    schoolNames: {
      get() {
        const listOfSchools = this.$store.state.searchSchoolList;
        let selectListOfSchools = [
          {
            value: "",
            text: this.$t('All School Names'),
          }
        ];
        for (let i = listOfSchools.length - 1; i >= 0; i--) {
          selectListOfSchools.push({
            value: listOfSchools[i].id,
            text: listOfSchools[i].name
          });
        }

        selectListOfSchools.sort((a, b) => {
          if ( a.text < b.text ) {
            return -1;
          }
          if ( a.text > b.text ) {
            return 1;
          }
          return 0;
        });

        return selectListOfSchools;
      }
    },
    switcherMapList() {
      return this.$store.state.switcherMapList;
    },
    province: {
      get() {
        if (this.$store.state.currentMapProvince) {
          return this.$store.state.currentMapProvince;
        } else {
          return null;
        }
      },
      set(value) {
        let vm = this;
        if (value === 'Quebec') {
          value = 'Québec';
        }

        vm.$store.dispatch("setCurrentMapProvince", value);
        StorageService.setItem("currentMapProvince", value);
        if (value !== 'Québec') {
          vm.$store.dispatch('setCurrentLanguage', 'en');
          this.$i18n.locale = 'en';
        }

        // Set center map with currentMapProvince location.
        let listProvinces = this.$store.state.provinceList;
        listProvinces.forEach(function(province_value) {
          if (province_value.name === value) {
            vm.$store.dispatch(
              "setCurrentMapLocation",
              province_value.location
            );
          }
        });

        // Update map
        // TODO: double check on school_level test ui combination.

        let currentMapLocation = this.$store.state.currentMapLocation;

        /*console.info(
          {
            "element-model": 'v-model="province"',
            "action: ": "Province switching",
            "request": "Get Locations",
            time: Math.floor(Date.now() / 1000)
          },
          "EVENT"
        );*/
        this.getLocations(currentMapLocation.lat, currentMapLocation.lng);
        this.$store.commit("SET_SWITCHER_MAP_LIST", 'map');
        this.$store.commit("UPDATE_MAP_KEY", true);
      }
    },
    provinces: function() {
      let provinceList = this.$store.state.provinceList;
      provinceList.sort((a, b) => (a.name > b.name ? 1 : -1));
      let data = [];
      provinceList.forEach(function(item) {
        data.push({
          value: item.name,
          text: item.name,
          languages: item.languages
        });
      });
      return data;
    }
  },
  watch: {
    autocompleteSearch(val) {
      val && val !== this.select && this.querySelections(val);
    },
    $route (to){
      if(to.name == 'home') {
        setTimeout(() => {
          this.schoolSearch('home');
        }, 100);
      }
    }
  },
  asyncComputed: {

    autocompleteAllTerms: function() {
      // Force clean auto complete to avoid loading wrong list for different province.
      this.autocompleteItems = [];
      //Lets filter it by filters not by keyword or map location.
      let schools = this.$store.state.searchSchoolList;
      let rating = this.rating.slice(0);
      schools = schools.filter(school => {
        return (
          school.level == this.schoolEducationLevel &&
          (this.schoolType != ""
            ? school.type.toLowerCase() == this.schoolType.toLowerCase()
            : true) &&
          ((school.score >= rating[0] && school.score <= rating[1])
            || (school.id == '2396281' && school.score == 'n/a')
          ) &&
          (this.schoolAutority != ""
            ? school.areaName == this.schoolAutority
            : true) &&
          (this.schoolLanguage != ""
            ? school.language.toLowerCase() == this.schoolLanguage.toLowerCase()
            : true) &&
          (this.schoolName != "" ? this.schoolName == school.id : true)
        );
      });
      let items = [];
      let cities = {};
      for (let i = schools.length - 1; i >= 0; i--) {
        items.push({type: 'school', label: schools[i].name, index: items.length});
        if(!cities[schools[i].city]) {
          cities[schools[i].city] = schools[i].city;
          items.push({type: 'city', label: schools[i].city, index: items.length});
        }
      }

      return [...new Set(items)];
    }
  },
  created() {
    this.languageInput = this.currentLanguage;
  },
  components: {
    bFormSlider
  }
};
</script>
